import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {GlobalComponentsModule} from '../global-components/global-components.module';
import {SharedComponentsModule} from './presentation/shared-components/shared-components.module';
import {BusinessLogicFacade} from './business-logic/business-logic.facade';
import {BusinessRequirementsInjectionToken} from './presentation/business-logic.requirements';
import {LiveClassesHomeModule} from './presentation/live-classes-home/live-classes-home.module';
import {TeacherProfileModule} from './presentation/teacher-profile/teacher-profile.module';

import {BusinessLogicRequirementsFake} from './presentation/business-logic.requirements.fake';

@NgModule({
    imports: [
        BusinessLogicFacade,
        CommonModule,
        GlobalComponentsModule,
        SharedComponentsModule,

        LiveClassesHomeModule,
        TeacherProfileModule
    ],
    providers: [
        {
            provide: BusinessRequirementsInjectionToken,
            useClass: BusinessLogicFacade
            // useClass: BusinessLogicRequirementsFake
        }
    ],
    exports: []
})
export class LiveClassesFeatureModule {}
